module.exports = __webpack_public_path__ + "img/erp_case6.f50818de.png";